
















































































































































































// 来源渠道表
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { marketCourseApi, marketComprehensiveInter } from "@/api/statistics";
import { dateFormat, getCurrentMonth } from "@/utils/timeFormat";
import json2csv from "json2csv";
import { roundNumbers } from "@/utils/roundNumbers";
@Component({
  components: {},
})
export default class extends Vue {
  @Prop() data!: any;
  tableData: any = [];
  currentSortOption: any = {
    order: "descending",
    prop: "",
  };
  paginationData: any = [];
  s_t: string = "";
  e_t: string = "";
  multiplemonth: boolean = false;
  exporting: boolean = false;
  @Watch("data", { immediate: false, deep: true })
  onChangeValue(v: any) {
    this.getList();
  }
  created() {
    this.getList();
  }
  getList() {
    if (this.data.region === 4 && this.data.source_id) {
      this.multiplemonth = true;
    } else {
      this.multiplemonth = false;
    }
    const params: marketComprehensiveInter = {
      start_time: this.data.start_time,
      end_time: this.data.end_time,
      query_time: this.data.query_time,
    };
    if (this.data.staff_id && this.data.region === 1) {
      params.course_adviser_id = Number(this.data.staff_id);
    }
    if (this.data.studentApp_id && this.data.region === 2) {
      params.appear_id = Number(this.data.studentApp_id);
    }
    if (this.data.source_id && this.data.region === 4) {
      params.source_id = Number(this.data.source_id);
    }
    marketCourseApi(params).then((res: any) => {
      if (res.error_code === 0) {
        let n = 1;
        res.data.list.map((item: any) => {
          item.num = n++;
          item.order_amount = roundNumbers(item.order_amount);
          item.contact_nuo_visit = roundNumbers(item.contact_nuo_visit);
          item.visit_nuo_transform = roundNumbers(item.visit_nuo_transform);
          item.visit_transform = roundNumbers(item.visit_transform);
          item.roster_transform = roundNumbers(item.roster_transform);
        });
        this.tableData = res.data.list;
        this.paginationData = res.data.list;
        this.handleSortChange({
          order: "descending",
          prop: "order_amount",
        });
      }
    });
  }
  handleSortChange(val: any) {
    this.currentSortOption = {
      order: val.order,
      prop: val.prop,
    };
    this.tableData = this.sortList(this.tableData);
    let n = 1;
    this.tableData.map((it: any) => {
      it.num = n++;
    });
  }
  sortList(val: any[]) {
    const copy = [...val];
    copy.sort((a: any, b: any) => {
      return (
        Number(b[this.currentSortOption.prop]) -
        Number(a[this.currentSortOption.prop])
      );
    });
    copy.map((it: any, ind: any) => {
      it.ind = ind + 1;
    });
    if (this.currentSortOption.order === "ascending") {
      copy.reverse();
    }
    return copy;
  }
  // 导出
  handleExport() {
    if (this.exporting) {
      return false;
    }
    this.exporting = true;
    const date: any = new Date().getTime();
    const dateTime = dateFormat("YYYYmmddHHMMSS", date);
    const endThree = String(date).slice(-3, date.length);
    try {
      const result = json2csv.parse(
        [
          {
            "source.name": "来源渠道",
            roster_num: "名单数",
            connected_num: "已联络",
            committed_to_visit_num: "诺访",
            visited_num: "已到访",
            transformed_num: "已转化",
            order_amount: "订单金额 (元)",
            visit_nuo_transform: "诺访到访率",
            visit_transform: "到访转化率",
            roster_transform: "名单转化率",
          },
          ...this.paginationData,
        ],
        {
          fields: [
            "source.name",
            "roster_num",
            "connected_num",
            "committed_to_visit_num",
            "visited_num",
            "transformed_num",
            "order_amount",
            "visit_nuo_transform",
            "visit_transform",
            "roster_transform",
          ],
          header: false,
        }
      );
      // 非IE浏览器
      const csvContent = "data:text/csv;charset=utf-8,\uFEFF" + result;
      // 创建a标签下载
      const link = document.createElement("a");
      link.href = encodeURI(csvContent);
      link.download = "市场综合数据" + dateTime + endThree;
      (".csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      // 3秒导出间隔
      setTimeout(() => {
        this.exporting = false;
      }, 3000);
      this.$message({
        message: "导出成功",
        type: "success",
      });
    } catch (err: any) {
      this.$message({
        type: "error",
        message: err.toString(),
      });
    }
  }
  toResource(scope: any) {
    let start_tamp: any = new Date(
      this.data.start_time + " 00:00:01"
    ).getTime();
    let end_tamp: any = new Date(this.data.end_time + " 23:59:59").getTime();
    this.$router.push({
      name: "resourceManagement",
      query: {
        start_time: start_tamp,
        end_time: end_tamp,
        source_id: scope.row.source.student_source_id,
      },
    });
  }
}
